export const LogoMark = ({ className = "h-10 w-auto", light = false, id = "lm" }) => {
  const ink = light ? "#FFFFFF" : "#111111";
  return (
    <svg viewBox="0 0 150 100" className={className} aria-hidden="true" data-testid="logo-mark">
      <defs>
        <mask id={`${id}-gap`}>
          <rect width="150" height="100" fill="#fff" />
          <rect x="40" y="14" width="110" height="4" fill="#000" />
        </mask>
      </defs>
      <g mask={`url(#${id}-gap)`}>
        <rect x="0" y="0" width="14" height="100" fill={ink} />
        <path d="M14 7 H30 A43 43 0 0 1 30 93 H14" fill="none" stroke={ink} strokeWidth="14" />
      </g>
      <rect x="40" y="0" width="82" height="14" fill={ink} />
      <rect x="122" y="0" width="28" height="14" fill="#E6D8B8" />
      <rect x="92" y="0" width="14" height="100" fill={ink} />
    </svg>
  );
};

export const Logo = ({ light = false, compact = false }) => {
  const ink = light ? "text-white" : "text-[#111111]";
  const sub = light ? "text-white/60" : "text-[#8E8D8A]";
  return (
    <span className="inline-flex items-center gap-3">
      <LogoMark
        light={light}
        id={light ? "lm-light" : "lm-dark"}
        className={compact ? "h-8 w-auto" : "h-9 w-auto sm:h-11"}
      />
      <span className="flex flex-col">
        <span className={`border-t ${light ? "border-white/40" : "border-[#111111]"}`} />
        <span
          className={`mt-1 font-display font-bold uppercase leading-none tracking-wide ${ink} ${
            compact ? "text-xl" : "text-2xl sm:text-[32px]"
          }`}
        >
          DT Timmerwerken
        </span>
        <span
          className={`mt-1 font-display text-[9px] font-bold uppercase tracking-[0.3em] ${sub} ${
            compact ? "" : "sm:text-[10px]"
          }`}
        >
          Opmeer · Noord-Holland
        </span>
      </span>
    </span>
  );
};
